import { createLoggerClient } from "norebase-wrappers-web";

export const loggerClient = createLoggerClient({
	appName:import.meta.env.VITE_APP_NAME,
	instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTATION_KEY
});